import React, { useEffect, useState } from "react";
import { Box, Card, Grid, Typography } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import AssignmentIcon from "@mui/icons-material/Assignment";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import DashboardIcon from "@mui/icons-material/Dashboard";
import axios from "axios";
import baseURL from "../../config";
import { useParams } from "react-router-dom";

const CrewingAgentDashboard = () => {
  const [fetchAllCount, setFetchAllCount] = useState({});
  const { id: crewingAgentId } = useParams();

  useEffect(() => {
    FetchAllCountsOfCrewingAgent();
  }, []);

  const FetchAllCountsOfCrewingAgent = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${baseURL}/api/crewingAgent/getAllCountsForCrewingAgent/${crewingAgentId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      console.log("response", response.data);
      setFetchAllCount(response?.data || {});
    } catch (error) {
      console.error("Error fetching counts", error);
    }
  };

  // Dynamically build stats array from API response
  const stats = [
    {
      label: "Assigned Contracts",
      value: fetchAllCount.assignedContractCount ?? 0,
      icon: <AssignmentIcon sx={{ fontSize: 35 }} />,
    },
    {
      label: "Pending Contract Approvals",
      value: fetchAllCount.pendingContractApprovalCount ?? 0,
      icon: <DashboardIcon sx={{ fontSize: 35 }} />,
    },
    {
      label: "Pending Form 1 Uploads",
      value: fetchAllCount.pendingForm1UploadCount ?? 0,
      icon: <DirectionsBoatIcon sx={{ fontSize: 35 }} />,
    },
    {
      label: "Uploaded Form 1",
      value: fetchAllCount.uploadedForm1Count ?? 0,
      icon: <PeopleIcon sx={{ fontSize: 35 }} />,
    },
  ];

  return (
    <Box>
      <Typography variant="h4" fontWeight="bold" sx={{ mb: 4, color: "#C30B12" }}>
        Overview
      </Typography>
      <Grid container spacing={3}>
        {stats.map((stat, idx) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={idx}>
            <Card
              sx={{
                height: 150,
                p: 2,
                textAlign: "center",
                borderRadius: 4,
                boxShadow: 4,
                background: "linear-gradient(135deg, #FBB80C, #e6a500)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                "&:hover": {
                  transform: "translateY(-5px)",
                  transition: "0.3s",
                  boxShadow: 6,
                },
              }}
            >
              <Box sx={{ color: "#C30B12", mb: 1 }}>{stat.icon}</Box>
              <Typography variant="h5" fontWeight="bold" color="#fff">
                {stat.value}
              </Typography>
              <Typography variant="body2" sx={{ color: "#fff" }}>
                {stat.label}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CrewingAgentDashboard;